export default __webpack_public_path__ + "11a527c2658be35c0d0c7116045cd237.svg";